import { ActionType } from 'src/types/common/common';
import {
  // optionsToNum,
  // generateLinkImg,
  generateResponsiveImage,
} from 'src/constrains/DraggableModules/tools';
import { ResponsiveCarouselAdaptor } from 'src/constrains/DraggableModules/Components';
import { dispatch } from '@/src/store';
import { onLoadData } from 'src/constrains/ResponsiveLayerEditor/slice';

const ResponsiveImageCarouselFunctions = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
  onCollapseOpen,
}) => {
  const handleOnCarouselItemAdd = (id, data) => {
    // const _n = optionsToNum[posterType] || 1;
    const _o = data || [generateResponsiveImage()];
    if (onDynamicChange) {
      onDynamicChange({ type: ActionType.add, id, data: _o });
    }
  };

  const handleOnCarouselItemDelete = (id, index) => {
    if (onDynamicChange) {
      onDynamicChange({ type: ActionType.delete, id, data: { index } });
    }
  };

  const handleOnCarouselItemChange = (id, index, modifiedData) => {
    if (onDynamicChange) {
      onDynamicChange({
        type: ActionType.modify,
        id,
        data: {
          index,
          modifiedData,
        },
      });
    }
  };

  const handleOnCarouselItemSort = (id, from, to) => {
    if (onDynamicChange) {
      onDynamicChange({
        type: ActionType.reorder,
        id,
        data: {
          from,
          to,
        },
      });
    }
  };

  const handleOnCarouselStaticChange = (id, data) => {
    if (onStaticChange) {
      onStaticChange({
        type: ActionType.modify,
        id,
        data,
      });
    }
  };

  const handleOnCloseAllCollapses = () => {
    if (onCollapseOpen) onCollapseOpen([]);
  };

  const handleOnCarouselModuleTypeChange = (data) => {
    if (onModuleTypeChange) {
      onModuleTypeChange(data);
    }
  };

  const handleOnOpenImageTab = (data) => {
    handleOnCloseAllCollapses();
    setTimeout(() => {
      dispatch(onLoadData(data));
    });
  };

  return {
    handleOnCarouselItemAdd,
    handleOnCarouselItemDelete,
    handleOnCarouselItemChange,
    handleOnCarouselItemSort,
    handleOnCarouselStaticChange,
    handleOnCarouselModuleTypeChange,
    handleOnOpenImageTab,
  };
};
const generateResponsiveImageCarousel = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
  onCollapseOpen,
}) => {
  const {
    handleOnCarouselItemAdd,
    handleOnCarouselItemDelete,
    handleOnCarouselItemChange,
    handleOnCarouselItemSort,
    handleOnCarouselStaticChange,
    handleOnCarouselModuleTypeChange,
    handleOnOpenImageTab,
  } = ResponsiveImageCarouselFunctions({
    onDynamicChange,
    onStaticChange,
    onModuleTypeChange,
    onCollapseOpen,
  });
  return {
    component: ResponsiveCarouselAdaptor,
    props: {
      onItemAdd: handleOnCarouselItemAdd,
      onItemChange: handleOnCarouselItemChange,
      onItemSort: handleOnCarouselItemSort,
      onItemDelete: handleOnCarouselItemDelete,
      onStaticChange: handleOnCarouselStaticChange,
      onModuleTypeChange: handleOnCarouselModuleTypeChange,
      onOpenNewTab: handleOnOpenImageTab,
    },
  };
};
export { generateResponsiveImageCarousel };
